(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3806],{

/***/ 76009:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/503",
      function () {
        return __webpack_require__(60486);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 60486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Custom503; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_useragent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28010);
/* harmony import */ var _providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8710);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82913);
/* harmony import */ var _components_ErrorPage_503__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(24270);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27101);








function Custom503(param) {
    var uaString = param.uaString;
    var ua = (0,next_useragent__WEBPACK_IMPORTED_MODULE_3__/* .useUserAgent */ .FS)(uaString);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_7__/* .SearchStoreProvider */ .YG, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_4__/* .RootStoreProvider */ .LD, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                    title: "Ошибка 503: страница не доступна"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_5__/* .Layout */ .A, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    isOutsPage: true,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ErrorPage_503__WEBPACK_IMPORTED_MODULE_6__/* .Page503 */ .g, {})
                })
            ]
        })
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(76009); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);